/* eslint-disable no-restricted-syntax */

// These promocodes can be applied only for given payment period
// keys represent payment period, values are arrays of promocodes specific only for given payment period
//
// for example:
//
// PROMOCODES_FOR_GIVEN_PERIOD_ONLY  = {
//   '12': ['UA25', 'UA40'],
//   '6': [],
//   '1': [],
// }
//  Promocode "UA25" can be applied only for 12 month period,
// It can not be applied if 6 month period is selected
//

// https://ctct.atlassian.net/browse/CPD-7570

export const PROMOCODES_FOR_GIVEN_PERIOD_ONLY: Record<string, string[]> = {
  '12': ['UA25', 'UA40'],
  '6': [],
  '1': [],
};

export const isCodeValidForPeriod = (code: string, period: string | undefined) => {
  for (const [restrictedPeriod, codes] of Object.entries(PROMOCODES_FOR_GIVEN_PERIOD_ONLY)) {
    if ((codes || []).includes(code)) {
      return restrictedPeriod === period;
    }
  }

  return true;
};

export const getValidPeriodForCode = (code: string) => {
  for (const [restrictedPeriod, codes] of Object.entries(PROMOCODES_FOR_GIVEN_PERIOD_ONLY)) {
    if ((codes || []).includes(code)) {
      return restrictedPeriod;
    }
  }

  return null;
};
